import { TeamInvitation, TeamInvitationStatus } from '../../domain/models';

export interface TeamInvitationEntity {
  id: string;
  team_id: string;
  team_name: string;
  inviter_id: string;
  invitee_id: string;
  invitee_name?: string | null;
  invitee_email?: string | null;
  status: string;
  message: string | null;
  created_at: string;
}

export const teamInvitationEntityToModel = (entity: TeamInvitationEntity): TeamInvitation => ({
  id: entity.id,
  teamId: entity.team_id,
  teamName: entity.team_name,
  inviterId: entity.inviter_id,
  inviteeId: entity.invitee_id,
  inviteeName: entity.invitee_name || undefined,
  inviteeEmail: entity.invitee_email || undefined,
  status: entity.status as TeamInvitationStatus,
  message: entity.message || undefined,
  createdAt: new Date(entity.created_at),
});
